import { CVEStatus } from '../../typings/enums';

type CVEStatusInfo = {
  name: string;
  //  For displaying in a standalone tooltip.
  tooltip: string;
  //  A shorter, simpler string of text explaining the status.
  simple: string;
};

export const cveStatusToInfo: Record<CVEStatus, CVEStatusInfo> = {
  [CVEStatus.Disputed]: {
    name: 'Disputed',
    tooltip: 'This CVE is disputed and may not be a valid vulnerability.',
    simple: 'Disputed and may not be a valid vulnerability',
  },
  [CVEStatus.Reserved]: {
    name: 'Reserved',
    tooltip: 'This CVE is reserved for future use.',
    simple: 'Reserved for future use',
  },
  [CVEStatus.Rejected]: {
    name: 'Rejected',
    tooltip: 'This CVE has been rejected.',
    simple: 'Rejected',
  },
  [CVEStatus.InReview]: {
    name: 'In Review',
    tooltip: 'This CVE is undergoing review.',
    simple: 'Undergoing review',
  },
  [CVEStatus.Completed]: {
    name: 'Reviewed',
    tooltip: 'This CVE has been reviewed and accepted by NIST and FOSSA.',
    simple: 'Reviewed and accepted by NIST and FOSSA',
  },
};
